import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import AppDetailPage from "@/pages/AppDetailPage";
import FounderPage from "@/pages/FounderPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import PrivacyPoliciesPage from "@/pages/PrivacyPoliciesPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import TermsOfServicesPage from "@/pages/TermsOfServicesPage";
import DisclosurePage from "@/pages/DisclosurePage";
import MarketingMaterialsPage from "@/pages/MarketingMaterialsPage";
import DeleteAccountPage from "@/pages/DeleteAccountPage";

// Debug: Production build verification
console.log("LifeCorp production build loaded: lifecorp-production-check-2026-01");
console.log("Build timestamp:", new Date().toISOString());

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/apps/:slug" element={<AppDetailPage />} />
        <Route path="/founder" element={<FounderPage />} />
        <Route path="/privacy" element={<PrivacyPoliciesPage />} />
        <Route path="/privacy/:slug" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicesPage />} />
        <Route path="/terms/:slug" element={<TermsOfServicePage />} />
        <Route path="/disclosure/:slug" element={<DisclosurePage />} />
        <Route path="/marketing/:slug" element={<MarketingMaterialsPage />} />
        <Route path="/:slug/delete-account" element={<DeleteAccountPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
